import { SignalRReceiveUpdatesRequotePartResponse } from "@/main/models/common/signalRReceiveUpdatesResponse";

export enum SignalRTypes {
	SIGNALR_CONNECT = "@signalR/SIGNALR_CONNECT",
	SIGNALR_DISCONNECT = "@signalR/SIGNALR_DISCONNECT",
	SIGNALR_USER_CONNECTED = "@signalR/SIGNALR_USER_CONNECTED",
	SIGNALR_CLEAR_RECEIVE_UPDATES_BYKEY = "@signalR/SIGNALR_CLEAR_RECEIVE_UPDATES_BYKEY",
	SIGNALR_CLEAR_ALL_RECEIVE_UPDATES = "@signalR/SIGNALR_CLEAR_ALL_RECEIVE_UPDATES",
	SIGNALR_RECEIVE_UPDATES = "@signalR/SIGNALR_RECEIVE_UPDATES",
}

export interface SignalRState {
	readonly isConnected: boolean;
	readonly content: { [key: number]: any };
	readonly sendUpdatesSignalRTypeCurrent: number;
}

export interface SignalRConnect {
	type: typeof SignalRTypes.SIGNALR_CONNECT;
}

export interface SignalRDisconnect {
	type: typeof SignalRTypes.SIGNALR_DISCONNECT;
}

export interface SignalRUserConnected {
	type: typeof SignalRTypes.SIGNALR_USER_CONNECTED;
}

export interface SignalRReceiveUpdates {
	type: typeof SignalRTypes.SIGNALR_RECEIVE_UPDATES;
	payload: {
		content: SignalRReceiveUpdatesRequotePartResponse;
	};
}

export interface SignalRClearReceiveUpdatesByKey {
	type: typeof SignalRTypes.SIGNALR_CLEAR_RECEIVE_UPDATES_BYKEY;
	payload: {
		key: number;
	};
}

export interface SignalRClearAllReceiveUpdates {
	type: typeof SignalRTypes.SIGNALR_CLEAR_ALL_RECEIVE_UPDATES;
}

export type SignalRActionTypes =
	| SignalRConnect
	| SignalRDisconnect
	| SignalRUserConnected
	| SignalRReceiveUpdates
	| SignalRClearReceiveUpdatesByKey
	| SignalRClearAllReceiveUpdates;
